import React from 'react';
import { Paper } from '@mui/material';
import { ExtractedDataTable } from './ExtractedDataTable';
import { RightPanelHeader } from './RightPanelHeader';


export const RightPanel: React.FC = () => {

  return (
    <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }} variant="outlined">
      <RightPanelHeader />
      <ExtractedDataTable />
    </Paper>
  );
};